import type { FC, ReactNode } from 'react';
import { Button, Tooltip } from '@george-labs.com/design-system';

import { useHighlightContext } from './HighlightContext';

interface Props {
    label: ReactNode;
    tooltip: ReactNode;
    onClick: () => void;
}

export const HighlightButton: FC<Props> = ({ label, onClick, tooltip }) => {
    const { dataCy } = useHighlightContext();

    if (tooltip) {
        return (
            <Tooltip content={tooltip} tag="div" data-cy={`${dataCy}-highlight-tooltip`}>
                <Button
                    data-cy={`${dataCy}-highlight-button`}
                    variant={Button.VARIANT.SECONDARY}
                    size={Button.SIZE.SMALL}
                    className="my-2"
                    disabled
                >
                    {label}
                </Button>
            </Tooltip>
        );
    }

    return (
        <Button
            data-cy={`${dataCy}-highlight-button`}
            variant={Button.VARIANT.SECONDARY}
            onClick={onClick}
            size={Button.SIZE.SMALL}
            className="my-2"
        >
            {label}
        </Button>
    );
};
